import { useContext, useEffect } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { ProductContext } from "../context/ProductContext";
import HomeMain from "../layouts/main/HomeMain";

import { Helmet } from "react-helmet-async";

const Container = styled.article`
  color: ${(props) => props.theme.textColor};
`;
const Section = styled.section`
  height: 100vh;
`;
const Flex = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;
const Home = () => {
  const { t, i18n } = useTranslation();
  const { loadProducts } = useContext(ProductContext);

  useEffect(() => {
    loadProducts();
  }, [i18n.language]);

  const seoData = {
    en: {
      title: "Wholesale Nicotine Pouches across Europe – B2B SnusCo",
      description:
        "Order premium nicotine pouches in bulk for your tobacco shop from B2B SnusCo GmbH. We deliver across Europe with a special focus on Austrian tobacco shops!",
      keywords:
        "snusco, b2b snusco, wholesale nicotine pouches, bulk nicotine pouches, tobacco shop supplies, nicotine pouches Europe, Austrian tobacco shops",
      ogTitle: "Wholesale Nicotine Pouches across Europe – B2B SnusCo GmbH",
      ogDescription:
        "Bulk nicotine pouches for tobacco shops across Europe. Special focus on Austrian shops. Partner with B2B SnusCo GmbH today!",
      twitterTitle:
        "Wholesale Nicotine Pouches across Europe – B2B SnusCo GmbH",
      twitterDescription:
        "Order bulk nicotine pouches for your tobacco shop. Delivery across Europe with emphasis on Austrian shops!",
      url: "https://b2b.snusco.at/",
      image: "https://b2b.snusco.at/images/snuspouch.jpg",
      locale: "en",
    },
    de: {
      title: "Großhandel Nikotinsäcke europaweit – B2B SnusCo GmbH",
      description:
        "Bestellen Sie hochwertige Nikotinsäcke im Großhandel für Ihr Tabakgeschäft bei B2B SnusCo GmbH. Lieferung in ganz Europa mit Schwerpunkt auf österreichischen Tabakgeschäften!",
      keywords:
        "snusco, b2b snusco, Großhandel Nikotinsäcke, europäischer Großhandel, Tabakladenbedarf, Bulk Nikotinsäcke, Nikotinsäcke Europa, österreichische Tabakgeschäfte",
      ogTitle: "Großhandel Nikotinsäcke europaweit – B2B SnusCo GmbH",
      ogDescription:
        "Großhandelsnikkotinsäcke für Tabakgeschäfte in ganz Europa. Schwerpunkt auf österreichischen Tabakgeschäften. Jetzt Partner werden!",
      twitterTitle: "Großhandel Nikotinsäcke europaweit – B2B SnusCo GmbH",
      twitterDescription:
        "Bestellen Sie Bulk Nikotinsäcke für Ihr Tabakgeschäft. Lieferung in ganz Europa mit Schwerpunkt auf österreichischen Shops!",
      url: "https://b2b.snusco.at/",
      image: "https://b2b.snusco.at/images/snuspouch.jpg",
      locale: "de",
    },
  };

  const currentSeo = seoData[i18n.language] || seoData.en;

  return (
    <>
      <Helmet>
        {/* Meta Title */}
        <title>{currentSeo.title}</title>

        {/* Meta Description */}
        <meta name="description" content={currentSeo.description} />

        {/* Meta Keywords */}
        <meta name="keywords" content={currentSeo.keywords} />

        {/* Open Graph Meta Tags */}
        <meta property="og:title" content={currentSeo.ogTitle} />
        <meta property="og:description" content={currentSeo.ogDescription} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={currentSeo.url} />
        <meta property="og:image" content={currentSeo.image} />

        {/* Twitter Card Meta Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={currentSeo.twitterTitle} />
        <meta
          name="twitter:description"
          content={currentSeo.twitterDescription}
        />
        <meta name="twitter:image" content={currentSeo.image} />

        {/* Canonical Link */}
        <link rel="canonical" href={currentSeo.url} />

        {/* Additional Meta Tags */}
        <meta property="og:locale" content={currentSeo.locale} />
        <meta name="robots" content="index, follow" />
      </Helmet>

      <HomeMain />
    </>
  );
};

export default Home;
